var _defs, _g;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 170.39,
    viewBox: "0 0 139 170.39",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d380b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#733a0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#9d560d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf6f00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.13,
    r: 0.888,
    gradientTransform: "translate(0.595 -0.37) rotate(90) scale(1 0.725)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#441a09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#451b09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#733a0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#9d560d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#975a14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#613b15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#ba7721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.138,
    stopColor: "#eaa42c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd152"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_34379",
    x: 68,
    y: 0,
    width: 71,
    height: 170.39,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a36d10",
    floodOpacity: 0.49
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-linear-gradient-3",
    x1: 0.525,
    x2: 0.589,
    y2: 0.81,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d251b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.054,
    stopColor: "#bc9a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#cab0a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_34379-2",
    x: 0,
    y: 0,
    width: 71,
    height: 170.39,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a36d10",
    floodOpacity: 0.49
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_35442",
    x: 27.843,
    y: 23.358,
    width: 87.863,
    height: 86.372,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-linear-gradient-6",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#461010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#452121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#d5c5b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2d9c2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-linear-gradient-7",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#552010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#b56262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#fbf4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbf4e0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-linear-gradient-8",
    x1: 0.183,
    y1: -0.007,
    x2: 0.692,
    y2: 0.917,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4b4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#504f54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f2b2b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendar-linear-gradient-9",
    x1: 0.183,
    y1: -0.007,
    x2: 0.692,
    y2: 0.917,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#928888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#dbdade"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f9298"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250.5 -75.532)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 93.263,
    rx: 5,
    transform: "translate(265 93.737)",
    fill: "url(#calendar-linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 92,
    rx: 4,
    transform: "translate(266 94)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39 -54.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(255 -0.813)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -43.5, 130.85)",
    filter: "url(#Path_34379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-42.654H26V67.665L13.528,82.736,0,67.665Z",
    transform: "translate(90.5 60.15)",
    fill: "url(#calendar-linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0-37.671V67.641L13.528,82.707,26,67.641,25.893-42.853h-26m-1.893,0H27.766L28,68.374,13.589,85.781-2,68.42Z",
    transform: "translate(47 191)",
    fill: "url(#calendar-linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(308.25 227.528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1476.5,20a8.009,8.009,0,0,0,8-8,8.009,8.009,0,0,0-8-8c-.166,0-.334.005-.5.015v1.5c.161-.012.329-.019.5-.019A6.507,6.507,0,0,1-1470,12a6.508,6.508,0,0,1-6.5,6.5c-.166,0-.334-.006-.5-.019v1.5C-1476.828,19.995-1476.66,20-1476.5,20Z",
    transform: "translate(1482 -4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1476.5,20a8.009,8.009,0,0,0,8-8,8.009,8.009,0,0,0-8-8c-.166,0-.334.005-.5.015v1.5c.161-.012.329-.019.5-.019A6.507,6.507,0,0,1-1470,12a6.508,6.508,0,0,1-6.5,6.5c-.166,0-.334-.006-.5-.019v1.5C-1476.828,19.995-1476.66,20-1476.5,20Z",
    transform: "translate(1482 14.472)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1469,20a8.009,8.009,0,0,1-8-8,8.009,8.009,0,0,1,8-8c.166,0,.334.005.5.015v1.5c-.161-.012-.329-.019-.5-.019a6.507,6.507,0,0,0-6.5,6.5,6.508,6.508,0,0,0,6.5,6.5c.166,0,.334-.006.5-.019v1.5C-1468.672,19.995-1468.84,20-1469,20Z",
    transform: "translate(1477 5.472)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-29 -54.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(255 -0.813)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 24.5, 130.85)",
    filter: "url(#Path_34379-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-42.654H26V67.665L13.528,82.736,0,67.665Z",
    transform: "translate(22.5 60.15)",
    fill: "url(#calendar-linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0-37.671V67.641L13.528,82.707,26,67.641,25.893-42.853h-26m-1.893,0H27.766L28,68.374,13.589,85.781-2,68.42Z",
    transform: "translate(47 191)",
    fill: "url(#calendar-linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(308.25 227.528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1476.5,20a8.009,8.009,0,0,0,8-8,8.009,8.009,0,0,0-8-8c-.166,0-.334.005-.5.015v1.5c.161-.012.329-.019.5-.019A6.507,6.507,0,0,1-1470,12a6.508,6.508,0,0,1-6.5,6.5c-.166,0-.334-.006-.5-.019v1.5C-1476.828,19.995-1476.66,20-1476.5,20Z",
    transform: "translate(1482 -4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1476.5,20a8.009,8.009,0,0,0,8-8,8.009,8.009,0,0,0-8-8c-.166,0-.334.005-.5.015v1.5c.161-.012.329-.019.5-.019A6.507,6.507,0,0,1-1470,12a6.508,6.508,0,0,1-6.5,6.5c-.166,0-.334-.006-.5-.019v1.5C-1476.828,19.995-1476.66,20-1476.5,20Z",
    transform: "translate(1482 14.472)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1469,20a8.009,8.009,0,0,1-8-8,8.009,8.009,0,0,1,8-8c.166,0,.334.005.5.015v1.5c-.161-.012-.329-.019-.5-.019a6.507,6.507,0,0,0-6.5,6.5,6.508,6.508,0,0,0,6.5,6.5c.166,0,.334-.006.5-.019v1.5C-1468.672,19.995-1468.84,20-1469,20Z",
    transform: "translate(1477 5.472)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.206 -9.109)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.1-4.063,70.946,0s-1.161,26.576-1.412,44.262a58.545,58.545,0,0,0,7.781,30.1s-28.155-3.14-49.144-2.525A204.834,204.834,0,0,0-9.915,76.615s5.87-21.91,8.054-40.476S2.1-4.063,2.1-4.063Z",
    transform: "translate(273.527 111.814)",
    fill: "#973600",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 237.29, 84.64)",
    filter: "url(#Path_35442)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H66L62.137,68.372h-66Z",
    transform: "translate(40.71 26.36)",
    fill: "#9f916a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H66L62.137,68.372h-66Z",
    transform: "translate(277 109.814)",
    fill: "#bfb28f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H66L61.048,68.422h-66Z",
    transform: "translate(277 107.814)",
    fill: "url(#calendar-linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0A235.5,235.5,0,0,0,32.359,2.513,267.666,267.666,0,0,0,66,0s-1.686,8.181-2.379,25.037S67.1,68.287,67.1,68.287s-12.4-.216-24.708,0-20.956,0-28.394,0c-16.6,0-20.954-.863-20.954-.863A283.458,283.458,0,0,0-2.177,37.186C-.438,20.331,0,0,0,0Z",
    transform: "translate(275.931 106.628)",
    fill: "#fbf4e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0A235.5,235.5,0,0,0,32.359,2.513,267.666,267.666,0,0,0,66,0s-1.686,8.181-2.379,25.037S67.1,68.287,67.1,68.287s-12.4-.216-24.708,0-20.956,0-28.394,0c-16.6,0-20.954-.863-20.954-.863A283.458,283.458,0,0,0-2.177,37.186C-.438,20.331,0,0,0,0Z",
    transform: "translate(275.931 106.628)",
    fill: "url(#calendar-linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(279.003 109.464)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.577,0A215.963,215.963,0,0,0,29.1,2.3,245.463,245.463,0,0,0,59.948,0S58.4,7.5,57.767,22.96s3.192,39.663,3.192,39.663-11.373-.2-22.659,0-19.218,0-26.039,0c-15.225,0-19.216-.792-19.216-.792A259.946,259.946,0,0,0-2.573,34.1C-.979,18.644-.577,0-.577,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.3940544128417969 1.154636383056641 C 0.2770729064941406 5.438831329345703 -0.2224922180175781 21.05674362182617 -1.5787353515625 34.2044563293457 C -2.894306182861328 46.95774841308594 -5.045024871826172 57.66806411743164 -5.749092102050781 60.98856735229492 C -3.800239562988281 61.21096801757812 1.290328979492188 61.62272644042969 12.26121520996094 61.62272644042969 C 14.36333465576172 61.62272644042969 16.58815383911133 61.64163589477539 18.943603515625 61.66166687011719 C 21.64818572998047 61.68465805053711 24.71361351013184 61.71071624755859 28.04897499084473 61.71071624755859 C 31.56582450866699 61.71071624755859 34.91329193115234 61.68198776245117 38.28264617919922 61.62287521362305 C 41.616943359375 61.56439590454102 45.28699493408203 61.53473663330078 49.19083404541016 61.53473663330078 C 53.94785690307617 61.53473663330078 57.90810775756836 61.5794563293457 59.7929801940918 61.60519027709961 C 59.47354888916016 59.45876693725586 58.7769660949707 54.57737731933594 58.13066482543945 48.69734573364258 C 57.3262939453125 41.37913513183594 56.43688583374023 30.96634674072266 56.76773452758789 22.91908645629883 C 57.25271987915039 11.12267303466797 58.25314712524414 3.992473602294922 58.72035217285156 1.177677154541016 C 54.54946136474609 1.729618072509766 41.55694580078125 3.304187774658203 29.09800338745117 3.304187774658203 C 16.4691047668457 3.304187774658203 4.113235473632812 1.686374664306641 0.3940544128417969 1.154636383056641 M -0.5769271850585938 -3.814697265625e-06 C -0.5769271850585938 -3.814697265625e-06 13.96668243408203 2.304187774658203 29.09800338745117 2.304187774658203 C 44.22932434082031 2.304187774658203 59.9483528137207 -3.814697265625e-06 59.9483528137207 -3.814697265625e-06 C 59.9483528137207 -3.814697265625e-06 58.40240478515625 7.502456665039062 57.76689529418945 22.96016693115234 C 57.13137435913086 38.41788482666016 60.95910263061523 62.62272644042969 60.95910263061523 62.62272644042969 C 60.95910263061523 62.62272644042969 49.58645629882812 62.42475509643555 38.30018615722656 62.62272644042969 C 27.01391410827637 62.82069778442383 19.08210372924805 62.62272644042969 12.26121520996094 62.62272644042969 C -2.964004516601562 62.62272644042969 -6.955074310302734 61.83085632324219 -6.955074310302734 61.83085632324219 C -6.955074310302734 61.83085632324219 -4.167995452880859 49.55955505371094 -2.573455810546875 34.10184478759766 C -0.9789276123046875 18.64412689208984 -0.5769271850585938 -3.814697265625e-06 -0.5769271850585938 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#c84848"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(293.727 111.429) rotate(9)",
    fill: "#563d3d",
    stroke: "#927e7e",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4.5,
    rx: 4,
    ry: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4.5,
    rx: 3.5,
    ry: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(315 112.582) rotate(-3)",
    fill: "#563d3d",
    stroke: "#927e7e",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4.5,
    rx: 4,
    ry: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4,
    cy: 4.5,
    rx: 3.5,
    ry: 4,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 5.063,
    height: 14,
    rx: 2.531,
    transform: "matrix(0.996, 0.087, -0.087, 0.996, 295.529, 104.847)",
    fill: "url(#calendar-linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.063,
    height: 14,
    rx: 2.531,
    transform: "matrix(0.996, 0.087, -0.087, 0.996, 294.529, 102.847)",
    fill: "url(#calendar-linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "winter-calendar-day",
    textAnchor: "middle",
    transform: "translate(306 151)",
    fill: "#8a1515",
    fontSize: 30,
    fontFamily: "Open Sans",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8.789,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "winter-calendar-month",
    textAnchor: "middle",
    transform: "translate(305 166)",
    fill: "#412b1f",
    fontSize: 15,
    fontFamily: "Open Sans",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14.531,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25638",
    "data-name": "Group 25638",
    transform: "translate(6.073 70.089) rotate(-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.063,
    height: 14,
    rx: 2.531,
    transform: "matrix(0.996, 0.087, -0.087, 0.996, 293.355, 104.371)",
    fill: "url(#calendar-linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.063,
    height: 14,
    rx: 2.531,
    transform: "matrix(0.996, 0.087, -0.087, 0.996, 294.529, 102.847)",
    fill: "url(#calendar-linear-gradient-9)"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.3e5414b1.svg";
export { ForwardRef as ReactComponent };